// Shared styling primitives, mirroring the dashboard design language:
// a green gradient reserved for primary actions / selected state, a silver
// divider, and a no-color "shadow icon" container.

export const PRIMARY_GRADIENT =
  "bg-gradient-to-r from-lime-300 to-green-300 text-zinc-900 shadow-sm shadow-lime-400/20 hover:opacity-90";

export const SILVER_DIVIDER =
  "bg-gradient-to-r from-transparent via-zinc-300 dark:via-zinc-600 to-transparent";

export const SHADOW_ICON =
  "rounded-lg bg-muted/60 dark:bg-zinc-800/50 ring-1 ring-border/60 shadow-sm text-muted-foreground";

export const SILVER_CARD =
  "rounded-2xl border border-border/60 bg-gradient-to-r from-zinc-100/70 via-background to-zinc-100/50 dark:from-zinc-900/80 dark:via-background dark:to-zinc-900/60";
